/**
 * Vodorovné pásy webu (karty služeb, realizace) – Swiper. Jedna inicializace
 * pro všechny `.js-slider`, ať se pásy chovají všude stejně:
 *
 *  - tažení myší i prstem, vodorovné gesto na trackpadu, šipky na klávesnici
 *  - šipky .slider-prev / .slider-next v hlavičce stejné sekce
 *  - šířku položek určuje CSS (slidesPerView: 'auto'), Swiper jen posouvá
 *  - položka, na kterou se skočí tabulátorem, se posune do záběru
 *
 * Knihovna (~45 kB gzip) se stahuje až ve chvíli, kdy je pás kousek pod
 * obrazovkou (stejný princip jako Choices v kominik.local) – úvod stránky
 * ji neplatí. Do té doby pás funguje jako nativní vodorovné posouvání
 * se stejnými mezerami, takže při náběhu Swiperu nic neposkočí.
 */
import { loadVendor } from './lazy-vendor.js';

const SWIPER = '/www/assets/js/vendor/Swiper/swiper-bundle.min.js';

function initSlider(el) {
    if (typeof Swiper === 'undefined') return;

    const section = el.closest('section') || el.parentElement;
    const swiper  = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 14,
        grabCursor: true,
        watchOverflow: true,
        mousewheel: { forceToAxis: true },
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
            prevEl: section.querySelector('.slider-prev'),
            nextEl: section.querySelector('.slider-next'),
        },
        a11y: {
            slideLabelMessage: '{{index}} z {{slidesLength}}',
            slideRole: 'group',
            containerRoleDescriptionMessage: 'karusel',
            itemRoleDescriptionMessage: 'položka',
            prevSlideMessage: 'Předchozí',
            nextSlideMessage: 'Další',
        },
        breakpoints: {
            820: { spaceBetween: 20 },
            1180: { spaceBetween: 24 },
        },
    });

    el.addEventListener('focusin', (event) => {
        const slide = event.target.closest('.swiper-slide');
        if (!slide) return;
        const view = el.getBoundingClientRect();
        const box  = slide.getBoundingClientRect();
        if (box.left < view.left || box.right > view.right) {
            swiper.slideTo([...swiper.slides].indexOf(slide));
        }
    });
}

async function initSliders(sliders) {
    if (!await loadVendor(SWIPER)) return; // nedorazila → zůstane nativní posouvání
    sliders.forEach((el) => {
        if (!el.classList.contains('swiper-initialized')) initSlider(el);
    });
}

function initSlidersLazy() {
    const sliders = [...document.querySelectorAll('.js-slider')];
    if (!sliders.length) return;

    if (!('IntersectionObserver' in window)) { initSliders(sliders); return; }

    const io = new IntersectionObserver((entries, obs) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        obs.disconnect();
        initSliders(sliders);
    }, { rootMargin: '600px 0px' });

    sliders.forEach((s) => io.observe(s));
}

initSlidersLazy();
